module.exports = __webpack_public_path__ + "static/reviews_mobile-b8d8e15359d2700e5b2f057e494920ec.webp";